import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'app/components/v2/components/Button';
import Dialog from 'app/components/v2/components/Dialog';
import DialogActions from 'app/components/v2/components/Dialog/DialogActions';
import DialogContent from 'app/components/v2/components/Dialog/DialogContent';
import DialogTitle from 'app/components/v2/components/Dialog/DialogTitle';
import IconButton from 'app/components/v2/components/IconButton';
import LoadingOverlay from 'app/components/v2/components/LoadingOverlay';
import { useBoolean } from 'app/components/v2/hooks';

// Local Typings
interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  isLoading?: boolean;
  onOpen?: () => void;
  title: string;
}

// Component Definition
const HelpDialogWithIconButton: FC<Props> = ({
  children,
  isLoading,
  onOpen,
  title,
}) => {
  const { t } = useTranslation('components');

  const {
    handleSetFalse: handleClose,
    handleSetTrue: handleOpen,
    isTrue: isDialogOpen,
  } = useBoolean();

  useEffect(() => {
    if (isDialogOpen && onOpen) {
      onOpen();
    }
  },
  [isDialogOpen, onOpen]);

  return (
    <>
      <IconButton
        buttonSize="sm"
        circle
        iconName="help"
        minimize
        onClick={handleOpen}
      />

      <Dialog
        isOpen={isDialogOpen}
        onClose={handleClose}
        size="lg"
        withCloseButton
      >
        <DialogContent fullWidth>
          <LoadingOverlay isLoading={!!isLoading} />
          <DialogTitle>
            {title}
          </DialogTitle>

          {children}

        </DialogContent>
        <DialogActions noPaddingTop>

          <Button onClick={handleClose}>
            {t('common:close', 'Close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default HelpDialogWithIconButton;
